var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarChartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0999 4.5H9.8999V13.5H8.0999V4.5ZM11.6999 8.1H13.4999V13.5H11.6999V8.1ZM4.4999 9.9H6.2999V13.5H4.4999V9.9ZM11.6999 1.8H2.6999V16.2H15.2999V5.4H11.6999V1.8ZM0.899902 0.8928C0.899902 0.3996 1.3022 0 1.799 0H12.5999L17.0999 4.5V17.0937C17.1007 17.2119 17.0783 17.3291 17.0338 17.4386C16.9893 17.5481 16.9237 17.6478 16.8408 17.7319C16.7578 17.8161 16.659 17.8831 16.5501 17.9291C16.4413 17.9751 16.3244 17.9992 16.2062 18H1.7936C1.55724 17.9984 1.33102 17.9038 1.1638 17.7367C0.996578 17.5697 0.901788 17.3436 0.899902 17.1072V0.8928Z",
    fill: "#525866"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChartIcon);
export default __webpack_public_path__ + "static/media/bar-chart-icon.0ac72a826b833182959d4b370e1e36ea.svg";
export { ForwardRef as ReactComponent };